/**
 * @flow
 */
'use strict';

export const mappedFields: string[] = [
  'patient.lastName',
  'patient.firstName',
  'patient.name',
  'patient.streetName',
  'patient.email',
  'patient.phone',
  'patient.cell',
  'patient.medicalCard',
  'patient.medicalCardExp',
  'patient.medialcardversion',
  'patient.dateOfBirth',
  'patient.streetNumber',
  'patient.province',
  'patient.city',
  'patient.postalCode',
  'patient.address1',
  'patient.address2',
  'visit.prescription.od.sph',
  'visit.prescription.os.sph',
  'visit.prescription.od.cyl',
  'visit.prescription.os.cyl',
  'visit.prescription.od.axis',
  'visit.prescription.os.axis',
  'visit.prescrition.od.add',
  'visit.prescription.os.add',
  'visit.prescription.od.refraction',
  'visit.prescription.os.refraction',
  'visit.purchase.add',
  'visit.examDate',
  'visit.prescription.ou.add',
  'visit.prescription.ou.addVA',
];
